import React from 'react';
import { Stack, Typography } from '@mui/material';

import { Circle } from './styles';

const LegendItem = ({ color, label }) => (
  <Stack
    direction='row' alignItems='center' spacing='10px'>
    <Circle
      color={color} size='10px'
    />
    <Typography>{label}</Typography>
  </Stack>
);

export default LegendItem;
